import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import Layout from './Layout';

type StudentLayoutProps = PropsWithChildren & {
  className?: string;
};

export default function StudentLayout({
  children,
  className,
}: StudentLayoutProps) {
  return (
    <Layout
      className={twMerge(
        'rounded-xl bg-base-100 px-4 py-2 md:px-4 md:py-2 lg:px-13 lg:py-6',
        className,
      )}
    >
      {children}
    </Layout>
  );
}
